module.exports = __webpack_public_path__ + "img/deye.194ad4c9.webp";